import { Action } from '@ngrx/store';
import { Collection } from 'src/app/models/collection';

export const CollectionAction = {
    addForceCollectionContentRefresh:
        '[collection] add refresh content on next pull',
    createCollection: '[collection] create collection',
    deleteCollection: '[collection] delete collection',
    forceCollectionRefresh: '[collection] refresh on next pull',
    removeForceCollectionContentRefresh:
        '[collection] remove refresh content on next pull',
    setActiveCollection: '[collection] set active collection',
    setCollections: '[collection] set collections',
    updateCollection: '[collection] update collection',
};

export class CreateCollection implements Action {
    type = CollectionAction.createCollection;
    constructor(public collection: Collection) {}
}

export class DeleteCollection implements Action {
    type = CollectionAction.deleteCollection;
    constructor(public collectionId: string) {}
}

export class ForceCollectionRefresh implements Action {
    type = CollectionAction.forceCollectionRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class AddForceCollectionContentRefresh implements Action {
    type = CollectionAction.addForceCollectionContentRefresh;
    constructor(public contentId: string) {}
}

export class RemoveForceCollectionContentRefresh implements Action {
    type = CollectionAction.removeForceCollectionContentRefresh;
}

export class SetActiveCollection implements Action {
    type = CollectionAction.setActiveCollection;
    constructor(public collection: Collection | undefined) {}
}

export class SetCollections implements Action {
    type = CollectionAction.setCollections;
    constructor(public collections: Collection[]) {}
}

export class UpdateCollection implements Action {
    type = CollectionAction.updateCollection;
    constructor(public collection: Collection) {}
}
